import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const ROWS = [{
  without: 'Improvised classes every day',
  with: 'Pre-built classes by level'
}, {
  without: 'Lowering rates out of fear',
  with: 'Charging premium rates with confidence'
}, {
  without: 'Students who disappear',
  with: 'A retention and follow-up system'
}, {
  without: 'Unpredictable income',
  with: 'A pricing calculator and CRM'
}, {
  without: 'No contracts or legal backup',
  with: 'A ready-to-use legal kit'
}];
export function ComparisonTable() {
  return <section className="px-5 py-8" data-id="element-39">
      <div className="mx-auto max-w-xl" data-id="element-40">
        <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-41">
          Without the Kit vs. With
          <span className="block text-[var(--pb-lime)]" data-id="element-42">
            Pickleball Coach 360
          </span>
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-43">
          {/* Without */}
          <div className="rounded-2xl border border-red-300/35 bg-[#251827]/95 p-3 shadow-lg shadow-black/20" data-id="element-44">
            <p className="mb-3 text-center text-xs font-800 uppercase tracking-wide text-red-200" data-id="element-45">
              Without the Kit
            </p>
            <ul className="space-y-2" data-id="element-46">
              {ROWS.map(r => <li key={r.without} className="flex items-start gap-1.5" data-id="element-47">
                  <XIcon size={14} className="mt-0.5 shrink-0 text-red-400" data-id="element-48" />
                  <span className="text-[12px] leading-snug text-white/70" data-id="element-49">
                    {r.without}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="rounded-2xl border border-[var(--pb-lime)]/45 bg-[#16263b]/95 p-3 shadow-lg shadow-black/20" data-id="element-50">
            <p className="mb-3 text-center text-xs font-800 uppercase tracking-wide text-[var(--pb-lime)]" data-id="element-51">
              With the Kit
            </p>
            <ul className="space-y-2" data-id="element-52">
              {ROWS.map(r => <li key={r.with} className="flex items-start gap-1.5" data-id="element-53">
                  <CheckIcon size={14} className="mt-0.5 shrink-0 text-[var(--pb-lime)]" data-id="element-54" />
                  <span className="text-[12px] font-500 leading-snug text-white" data-id="element-55">
                    {r.with}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}